import { Injectable } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserActivityService {
  private activity = new Subject<void>();
  private userActivityEnded = new Subject<void>();
  private userActivitySoonEnded = new Subject<void>();
  private readonly INACTIVITY_TIMEOUT = 1800000;
  private readonly WARNING_BEFORE_TIMEOUT = 300000;

  public updateActivity(): void {
    this.activity.next();
  }

  public userActivityEnded$(): Observable<void> {
    return this.userActivityEnded.asObservable();
  }

  public userActivitySoonEnded$(): Observable<void> {
    return this.userActivitySoonEnded.asObservable();
  }

  public userActivity$(): Observable<void> {
    return this.activity.asObservable();
  }

  public activityTracker$(): Observable<unknown> {
    return this.activity.pipe(
      switchMap(() => {
        return timer(this.INACTIVITY_TIMEOUT - this.WARNING_BEFORE_TIMEOUT).pipe(
          tap(() => {
            this.userActivitySoonEnded.next();
          }),
          switchMap(() =>
            timer(this.WARNING_BEFORE_TIMEOUT).pipe(
              tap(() => {
                this.userActivityEnded.next();
              })
            )
          )
        );
      })
    );
  }
}
